export const environment = {
  production: true,
  baseUrl: 'https://millionshow.kr',
};
